import { drift, lotus, petal } from '../motifs';
import { registerPlate } from '../registry';

const PINK = ['#ffd8e6', '#f080a8', '#b8406a'] as const;

/** 15 ดอกบัว: the lotus plate, plum lacquer with pink lotus flowers rising at both ends. */
registerPlate({
  id: 'lotus',
  name: 'ดอกบัว',
  ground: ['#80385a', '#56203c', '#3a1226'],
  trim: '#d8a0b8',
  text: { fill: ['#fff0f4', '#f8c8d8'], line: '#1e0812' },
  inset: [17, 15],
  front(p, f) {
    lotus(p, f.x + 5, f.y + 3, 9, PINK);
    lotus(p, f.x - 4, f.b, 6, PINK);
    lotus(p, f.r - 5, f.y + 2, 8, PINK);
    lotus(p, f.r + 3, f.b - 1, 5.5, PINK);
  },
  motion: {
    sprites: {
      petal: { w: 2, h: 2, draw: (p) => petal(p, 0, 0, PINK) },
      mote: { w: 1, h: 1, draw: (p) => p.px(0, 0, '#ffe9a0') },
    },
    play(a, t, f) {
      // Gold motes rising from the flowers, a petal or two drifting off.
      drift(a, 'mote', t, 3, f.x - 2, 12, f.y + 2, f.y - 12, { speed: 0.4, sway: 1.5 });
      drift(a, 'mote', t, 2, f.r - 8, 10, f.y, f.y - 12, { speed: 0.35, sway: 1.5, seed: 4 });
      drift(a, 'petal', t, 1, f.r - 2, 4, f.y + 4, f.b + 8, { speed: 0.2, seed: 7 });
    },
  },
});
